import * as ng from 'angular';
import { ComponentRegistration } from '../core';
import { ICountryResource, ISubdivisionResource, Dto } from '../data';
import * as Linq from 'linq-es5';
let template = require('./address.html');

class AddressComponent extends ComponentRegistration {

    constructor() {
        super('address', {
            controller: AddressController,
            templateUrl: template,
            controllerAs: 'address',
            bindings: {
                line1: '=?',
                line2: '=?',
                country: '=?',
                subdivision: '=?subdivision',
                city: '=?',
                postalCode: '=?',
                ngDisabled: "=?",
                isLoading: "=?",
                form: "&"
            }
        });
    }
}

interface IAddressController {
    validate(): void;
    applyValidity(input, validity, validatorName): void;
    onChange(): void;
    onCountrySelect(): void;
    loadCountries(): any;
    loadSubdivisions(code): any;
    subdivisionDisabled(): Boolean;
    onSubdivisionChanged(item): void;
    getSubdivisionDescription(): string;
    getSubdivisions(searchTerm): Array<Dto.ISubdivision>;
    getCountry(countryName): any;
    getSubdivision(subdivisionName): any;
}

interface IAddressFormController extends ng.IFormController {
    subdivisionInput: ng.IFormController;
}

class AddressController implements IAddressController {
    private static $inject: Array<string> = ['$scope', 'Country', 'Subdivision'];

    //private fields
    private hostForm: IAddressFormController;
    private selectedCountry: Dto.ICountry;
    private subdivisionSearchText: string;
    private subdivisions: Array<Dto.ISubdivision>;
    private selectedSubdivision: Dto.ISubdivision;
    private countryRequiresExactMatch: boolean;
    private countries: Array<Dto.ICountry>;

    //bindings
    private line1: string;
    private line2: string;
    private country: string;
    private _subdivision: string;
    private city: string;
    private postalCode: string;
    private ngDisabled: boolean;
    private isLoading: boolean;
    private form: Function;

    constructor(private $scope: ng.IScope,
        private Country: ICountryResource,
        private Subdivision: ISubdivisionResource) {

        console.log("Address controller loaded.");

    }

    public get subdivision() : string {
        return this._subdivision;
    }

    public set subdivision(val: string)
    {
        if (this._subdivision !== val) {
            this._subdivision = val;
            this.subdivisionSearchText = val;
        }
    }

    public $onInit(): void {
        let self = this;
        this.line1 = this.line1 || '';
        this.line2 = this.line2 || '';
        this.country = this.country || '';
        this.subdivision = this.subdivision || '';
        this.city = this.city || '';
        this.postalCode = this.postalCode || '';
        this.ngDisabled = this.ngDisabled || false;

        this.hostForm = this.form();
        if (!this.hostForm)
            throw "Form reference was not resolved by the execution of the expression.";

        this.loadCountries();
        console.log("Address controller activated.");

        let unregisterCountryListWatch = this.$scope.$watch("address.countries", (newValue, oldValue) => {
            //this is a one time watcher for on load so that sub division selection will load
            //with list of subdivisions for the selected country
            //(due to load dependency between it and country)
            //unregistered after first use beyond with different values

            if (newValue !== oldValue && (self.country && self.country !== '')) {
                self.selectedCountry = self.getCountry(self.country);
                self.loadSubdivisions(self.selectedCountry.code);
                self.subdivisionSearchText = self.subdivision;
                // unregisterCountryWatch();
                unregisterCountryListWatch();
            }
        });

        let unregisterCountryWatch = this.$scope.$watch("address.country", (newValue, oldValue) => {
            //this is a one time watcher for on load so that sub division selection will load
            //with list of subdivisions for the selected country
            //(due to load dependency between it and country)
            //unregistered after first use beyond with different values

            if (newValue !== oldValue) {
                self.selectedCountry = self.getCountry(self.country);
                self.loadSubdivisions(self.selectedCountry.code);
                self.subdivisionSearchText = self.subdivision;
                //  unregisterCountryWatch();
                unregisterCountryListWatch();
            }
        });

        this.$scope.$on('$destroy', () => {
            unregisterCountryWatch();
            unregisterCountryListWatch();
        });
    }

    public validate(): void {
        //use the ng-message name as the key for the set validity function
        //boolean expression that describes valid.

        if (this.selectedCountry) {
            //subdivision conditionally required
            //TODO: Verify $setValidity signature
            var requiredValidity = this.selectedCountry && (this.selectedCountry.subdivisionRequired && this.subdivisionSearchText !== "")
                || (!this.selectedCountry.subdivisionRequired);
            (this.hostForm.subdivisionInput as any).$setValidity('conditionalRequired', requiredValidity);

            //subidvision required to be exact match
            var requiresExactMatch = (this.selectedCountry && this.selectedCountry.subdivisionExactMatch);
            var canMatch = (this.subdivisions && this.subdivisions.length > 0);

            if (canMatch) {
                var isMatch = canMatch && Linq.From(this.subdivisions)
                    .Any((x) => { return x.name === this.subdivision; });

                var exactMatchValidity = (!requiresExactMatch || isMatch);

                (this.hostForm.subdivisionInput as any).$setValidity('exactMatch', exactMatchValidity);
            }
        }
    }

    public applyValidity(input, validity, validatorName): void {
        //if (((input.$error[validatorName] === undefined || input.$error[validatorName] === false)
        //        && validity === false)
        //    || input.$error[validatorName] === true && validity === true)
        input.$setValidity(validatorName, validity);
    }

    public onChange(): void {
        this.validate();
    }

    public onCountrySelect(): void {
        this.selectedCountry = this.getCountry(this.country);
        this.subdivision = '';
        this.selectedSubdivision = null;
        this.subdivisionSearchText = '';
        this.loadSubdivisions(this.selectedCountry.code);
        this.countryRequiresExactMatch = this.selectedCountry
            && this.selectedCountry.subdivisionExactMatch;
        this.validate();
        this.hostForm.subdivisionInput.$setUntouched();
    }

    public loadCountries(): ng.IPromise<any> {
        this.isLoading = true;
        return this.Country.query({}, {})
            .$promise
            .then((response) => {
                this.countries = response;
                // onCountrySelect();
            })
            .catch((e) => {
                console.log(e);
                //return exception.catcher('XHR Failed for Account.save')(e);
            })
            .finally(() => {
                this.isLoading = false;
            });
    }

    public loadSubdivisions(code): any {
        this.isLoading = true;
        return this.Subdivision.query({ code: code }, { code: code })
            .$promise
            .then((response) => {
                this.subdivisions = response;
            })
            .catch((e) => {
                console.log(e);
                //return exception.catcher('XHR Failed for Account.save')(e);
            })
            .finally(() => {
                this.isLoading = false;
            });
    }

    public subdivisionDisabled(): boolean {
        return this.ngDisabled
            || !(this.selectedCountry)
            || (this.selectedCountry && !this.selectedCountry.subdivisionRequired);
    }

    public onSubdivisionChanged(item): void {
        this.subdivision = (item)
            ? item.name
            : this.subdivisionSearchText;

        this.validate();
    }

    public getSubdivisionDescription(): string {
        return (this.selectedCountry && this.selectedCountry.subdivisionDescription)
            ? this.selectedCountry.subdivisionDescription
            : "Province / Region / State";
    }

    public getSubdivisions(searchTerm): Array<Dto.ISubdivision> {
        if (!searchTerm || searchTerm.length === 0) return this.subdivisions;

        var lowerTerm = searchTerm.toLowerCase();

        return Linq.From(this.subdivisions)
            .Where((x:Dto.ISubdivision) => {
                return x.name.toLowerCase().startsWith(lowerTerm)
                    || x.code.toString().toLowerCase().startsWith(lowerTerm);
            })
            .ToArray();
    }

    public getCountry(countryName): Dto.ICountry {
        return Linq.From(this.countries)
            .FirstOrDefault((x) => { return x.name == countryName; });
    }

    public getSubdivision(subdivisionName): Dto.ISubdivision {
        return Linq.From(this.subdivisions)
            .FirstOrDefault((x) => { return x.name == subdivisionName; });
    }
}

let addrComponent = new AddressComponent();
export default addrComponent;
export { addrComponent as AddressComponent, IAddressController, AddressController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/user-controls/address.ts